import type { ExpansionDefinition } from '../../../types/expansions';

export const ARK_NOVA_GAME_ID = 'ark-nova';
export const MARINE_WORLDS_EXPANSION_ID = 'ark-nova-marine-worlds';

export const marineWorldsExpansion: ExpansionDefinition = {
  id: MARINE_WORLDS_EXPANSION_ID,
  gameId: ARK_NOVA_GAME_ID,
  title: 'Ark Nova: Zwierzęta Wodne',
  shortTitle: 'Zwierzęta Wodne',
  description:
    'Zasady dodatku (akwaria, Rafa, przygotowanie, FAQ) są kompletne. 20 alternatywnych kart akcji istnieje w modelu danych, ale bez zweryfikowanej polskiej transkrypcji stron I/II.',
  type: 'module',
  enabledByDefault: false,
  requiresBaseGame: true,
  selectionMode: 'toggle',
  /** Rules ready; unverified alternative card texts keep status partial. */
  contentStatus: 'partial',
};
